import { MouseEvent, ReactElement, ReactNode } from 'react';

import ArrowDownIcon from '../../assets/icons/arrow-down.svg?react';
import ArrowUpIcon from '../../assets/icons/arrow-up.svg?react';
import { DevicesSelectorMenu } from '../DevicesSelector/DevicesSelectorMenu';
import { MeetControlContainer, MeetControlCta, MeetControlMenu } from './style';
import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';

export interface MeetControlProps {
	disabled?: boolean;
	'data-testid'?: string;
	$off?: boolean;
	$withMenu?: boolean;
	$menuOpened?: boolean;
	openMenu?: () => void;
	closeMenu?: () => void;
	menu?: ReactElement;
	vMenuPadding?: number;
	color?: string;
	onClick?: (evt: MouseEvent) => void;
	children?: ReactNode;
	triggerDataTest?: string;
}

export function MeetControl({
	disabled = false,
	'data-testid': dataTestId,
	$off = false,
	$withMenu = false,
	$menuOpened = false,
	openMenu,
	closeMenu,
	menu,
	vMenuPadding,
	color,
	onClick,
	children,
	triggerDataTest
}: Readonly<MeetControlProps>) {
	const theme = useThemeContext();

	return (
		<MeetControlContainer
			disabled={disabled}
			color={color}
			$withMenu={$withMenu}
			$menuOpened={$menuOpened}
		>
			<MeetControlCta
				data-testid={dataTestId}
				$off={$off}
				disabled={disabled}
				$withMenu={$withMenu}
				color={color}
				onClick={disabled ? undefined : onClick}
			>
				{children}
			</MeetControlCta>
			{$withMenu && (
				<DevicesSelectorMenu
					opened={$menuOpened}
					open={openMenu}
					close={closeMenu}
					$notRelative
					vMenuPadding={vMenuPadding}
					popChildren={menu}
					triggerDataTest={triggerDataTest}
				>
					<MeetControlMenu>
						{$menuOpened ? (
							<ArrowDownIcon fill={theme.colors.brand.primary[300]} height={8} width={12} />
						) : (
							<ArrowUpIcon fill={theme.colors.brand.primary[300]} height={8} width={12} />
						)}
					</MeetControlMenu>
				</DevicesSelectorMenu>
			)}
		</MeetControlContainer>
	);
}
